import { RealEstateLocation } from '../../models/real-estate-location.model';

export const REAL_ESTATE_LOCATIONS_MOCK: RealEstateLocation[] = [
  {
    id: 1,
    municipality: 'Asientos',
    neighborhood: 'Plutarco Elías Calles',
    state: 'Aguascalientes',
  },
  {
    id: 2,
    municipality: 'Asientos',
    neighborhood: 'Amarillas de Esparza',
    state: 'Aguascalientes',
  },
  {
    id: 3,
    municipality: 'Asientos',
    neighborhood: 'Emancipación (Borunda)',
    state: 'Aguascalientes',
  },
  {
    id: 4,
    municipality: 'Asientos',
    neighborhood: 'La Esperanza',
    state: 'Aguascalientes',
  },
  {
    id: 5,
    municipality: 'Asientos',
    neighborhood: 'Jilotepec',
    state: 'Aguascalientes',
  },
  {
    id: 6,
    municipality: 'Calvillo',
    neighborhood: 'Miguel Hidalgo (El Huarache)',
    state: 'Aguascalientes',
  },
  {
    id: 7,
    municipality: 'Calvillo',
    neighborhood: 'El Ocote',
    state: 'Aguascalientes',
  },
  {
    id: 8,
    municipality: 'Calvillo',
    neighborhood: 'Tanque de los Serna',
    state: 'Aguascalientes',
  },
  {
    id: 9,
    municipality: 'Calvillo',
    neighborhood: 'El Papantón',
    state: 'Aguascalientes',
  },
  {
    id: 10,
    municipality: 'Calvillo',
    neighborhood: 'Barranca del Roble',
    state: 'Aguascalientes',
  },
  {
    id: 11,
    municipality: 'Cosío',
    neighborhood: 'Tres Piedras',
    state: 'Aguascalientes',
  },
  {
    id: 12,
    municipality: 'Cosío',
    neighborhood: 'El Cerrito',
    state: 'Aguascalientes',
  },
  {
    id: 13,
    municipality: 'Cosío',
    neighborhood: 'Cosío',
    state: 'Aguascalientes',
  },
  {
    id: 14,
    municipality: 'Cosío',
    neighborhood: 'Materiales Puente Negro (Los Arenales)',
    state: 'Aguascalientes',
  },
  {
    id: 15,
    municipality: 'Cosío',
    neighborhood: 'Fracción la Punta (Licenciado Neder)',
    state: 'Aguascalientes',
  },
];
